export enum NavlinkType {
    Navlink = 1,
    Dropdown = 2
}